import core from './core.html';


appConfig.$inject = ['$locationProvider','$stateProvider', '$urlRouterProvider', '$httpProvider', 'ngAuthSettings', '$ocLazyLoadProvider','$qProvider'];

function appConfig($locationProvider,$stateProvider, $urlRouterProvider, $httpProvider, ngAuthSettings, $ocLazyLoadProvider,$qProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');

    if( __env.environment == "prod"){
        $locationProvider.html5Mode(true);
        $locationProvider.hashPrefix('');
    }
    $qProvider.errorOnUnhandledRejections(false);
    $ocLazyLoadProvider.config({debug: true});


    // $urlRouterProvider.otherwise('/app/login');
    $urlRouterProvider.otherwise(($injector, $location) => {
        if ($location.path()) return '404';
        else return ngAuthSettings.config.home_url;
    });

    $stateProvider
        .state('home', {
            url: "/",
            // abstract: true,
            template: core,
            controller: 'SharedController',
            controllerAs: 'shCtrl',
            resolve: {
                userData: userData
            }
        })
        .state('home.confirmationOrder', {
            url: __env.routes.confirmationOrder,
            template: `<confirmation-order sh-ctrl="shCtrl"></confirmation-order>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./confirmation-order/confirmation-order');
                            $ocLazyLoad.load({name: 'app.confirmationOrder'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        })
        .state('home.contact', {
            url: __env.routes.contact,
            template: `<contact sh-ctrl="shCtrl"></contact>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./contact/contact');
                            $ocLazyLoad.load({name: 'app.contact'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        })
        .state('home.clientDashboard', {
            url: __env.routes.clientDashboard,
            template: `<client-dashboard sh-ctrl="shCtrl"></client-dashboard>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./client-dashboard/client-dashboard');
                            $ocLazyLoad.load({name: 'app.clientDashboard'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        })
        .state('home.knowUs', {
            url: __env.routes.knowUs,
            template: `<know-us sh-ctrl="shCtrl"></know-us>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./know-us/know-us');
                            $ocLazyLoad.load({name: 'app.knowUs'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        })
        .state('home.register', {
            url: __env.routes.register,
            template: `<register sh-ctrl="shCtrl"></register>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./register/register');
                            $ocLazyLoad.load({name: 'app.register'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        })
        .state('home.users', {
            url: "users",
            template: `<users sh-ctrl="shCtrl"></users>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./users/users');
                            $ocLazyLoad.load({name: 'app.users'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        })
        .state('home.calculator', {
            url: "calculator",
            template: `<calculator sh-ctrl="shCtrl"></calculator>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./calculator/calculator');
                            $ocLazyLoad.load({name: 'app.calculator'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        })
        .state('home.salesHome', {
            url: "sales-home",
            template: `<sales-home sh-ctrl="shCtrl"></sales-home>`,
            resolve: {
                loadController: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let ctrl = require('./sales-home/sales-home');
                            $ocLazyLoad.load({name: 'app.salesHome'});
                            resolve(ctrl);
                        })
                    });
                }]
            }
        });

    userData.$inject = ['SessionService', '$state', 'CartService', 'SharedService', 'ngAuthSettings'];

    function userData(SessionService, $state, CartService, SharedService, ngAuthSettings) {

        companyData(SessionService, $state, SharedService, ngAuthSettings);

        let userData = {};
        let cartId = SessionService.get('cartId') || '';
        let userId = '';

        return SessionService.getGlobals().then(globals => {
            userData.globals = globals;
            try {
                userId = userData.globals.currentUser.userId;
            }
            catch (e) {
            }
            return CartService.getCartResumeData(cartId, userId).then(cartInfo => {
                userData.cartInfo = cartInfo;
                return SharedService.getInitialParams(userId).then(data => {
                    if (__env.clientName === 'eltemplo') {
                        //userData.globalCategories = data[0].data;
                        userData.categoriesMenu = data[0].data;
                        userData.params = data[1].data;
                        if (data[1].data.components) {
                            SessionService.put('components', data[1].data.components);
                        }
                    }else{
                        userData.globalCategories = data[0].data;
                        userData.categoriesMenu = data[1].data;
                        userData.banners = data[2].data;
                        userData.params = data[3].data;
                        if (data[3].data.components) {
                            SessionService.put('components', data[3].data.components);
                        }
                    }
                    SessionService.put('pickupStore', cartInfo.pickupStore);
                    return userData;
                }).catch(error => {
                    console.log(error);
                    return {};
                });
            }).catch(error => {
                console.log(error);
                return {};
            });
        }).catch(reason => {
            $state.go('login');
        });
    }

    function companyData(SessionService, $state, SharedService, ngAuthSettings) {

        SharedService.getCompanyData().then(val => {

            ngAuthSettings["site"] = val;
        });

    }

}

export default appConfig;





/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/app.config.js
 **/